/* ============================================================================
   Carrito Lejan — JS compartido por el CAJÓN y la PÁGINA /cart
   ----------------------------------------------------------------------------
   Extraído del `<script>` de `sections/cart-drawer.liquid` (2026-09-01). Cambia
   una sola cosa: `SECTION` deja de ser el id de la sección y pasa a `.lejcart`.

   Hace tres cosas: `layoutItems()` —que ajusta el ancho de la foto y ESCALA el
   tamaño del título hasta que quepa, igualando todos los de la lista—, el
   selector de talla inline («Modificar») y el `refresh()` del carrito.
   ========================================================================== */

  /* ==========================================================================
     Cart drawer — interacciones del rediseño.
     Se declara FUERA del custom element <cart-drawer> para que se ejecute
     aunque el elemento se re-hidrate, y se auto-protege contra doble init
     (la sección se re-renderiza entera en cada merge del carrito).
     ========================================================================== */
  (function () {
    if (window.__lejCartDrawerInit) return;
    window.__lejCartDrawerInit = true;

    var SECTION = '.lejcart';

    function cartForm() {
      return document.querySelector(SECTION + ' cart-form');
    }

    var ACTIONS_W = 48;
    var MAIN_GAP = 10;
    var TITLE_MIN_SCALE = 0.7;   /* suelo al que se puede encoger el título */

    /* ── Ancho de la foto: SOLO red de seguridad ───────────────────────────
       Desde v2 el ancho y el alto de la foto son fijos y los pone el CSS
       (`--lej-item-photo-w/h`), así que aquí no se calcula nada: solo se TOPA al
       hueco que queda libre en la tarjeta. Sin ese tope, en pantallas muy
       estrechas (el drawer cede por debajo de ~333px) la fila no cabe y la
       columna de acciones se envuelve a una segunda línea: la papelera acaba
       debajo de la foto y el stepper suelto al fondo. Si cabe, se limpia el
       inline y manda el CSS.                                                  */
    function setPhotoWidth(img, info, item) {
      var design = parseFloat(getComputedStyle(item).getPropertyValue('--lej-item-photo-w'));
      var inner = item.clientWidth - 20;   /* padding 10+10 */
      var room = inner - ACTIONS_W - MAIN_GAP - info.getBoundingClientRect().width;
      if (!design || room >= design) { img.style.width = ''; return; }
      img.style.width = Math.max(40, room).toFixed(2) + 'px';
    }

    /* ── Título: TODO el nombre en dos líneas como máximo, sin puntos
       suspensivos. Si no cabe al cuerpo de diseño, se encoge la letra en pasos
       de 0.25px hasta que entra (el `line-height` es fijo, así que la altura
       del bloque —y por tanto la de la foto y la tarjeta— no se mueve).        */
    function fitTitle(title) {
      title.style.fontSize = '';
      var lh = parseFloat(getComputedStyle(title).lineHeight);
      var base = parseFloat(getComputedStyle(title).fontSize);
      var max = lh * 2 + 1;
      if (title.scrollHeight <= max) return base;
      for (var fs = base - 0.25; fs >= base * TITLE_MIN_SCALE; fs -= 0.25) {
        title.style.fontSize = fs.toFixed(2) + 'px';
        if (title.scrollHeight <= max) return fs;
      }
      return base * TITLE_MIN_SCALE;
    }

    /* Todos los títulos del carrito al MISMO cuerpo: se calcula el que necesita
       cada uno y se aplica el menor a todos, para no mezclar dos tamaños de
       letra en líneas contiguas. */
    function fitAllTitles(titles) {
      if (!titles.length) return null;
      var smallest = titles.reduce(function (min, t) { return Math.min(min, fitTitle(t)); }, Infinity);
      titles.forEach(function (t) { t.style.fontSize = smallest.toFixed(2) + 'px'; });
      return smallest;
    }

    /* ── Nunca una palabra suelta al final del título ──────────────────────
       Con dos líneas, si la segunda se queda con UNA sola palabra se pega esa
       palabra a la anterior con un espacio duro para que el salto suba:
       "Sneaker Cleaner Kit" pasa de «Sneaker Cleaner / Kit» a
       «Sneaker / Cleaner Kit» (Hugo 2026-08-11).

       Se hace DESPUÉS de fijar el cuerpo (`fitAllTitles`) para no mezclar dos
       tamaños de letra, y se revierte si al pegarlas el título necesitara una
       línea más. El texto original se guarda en un data-* para que sea
       idempotente: cada re-layout parte del nombre limpio.                    */
    function lineTop(node, from, to) {
      var r = document.createRange();
      r.setStart(node, from);
      r.setEnd(node, to);
      var rects = r.getClientRects();
      return rects.length ? rects[rects.length - 1].top : null;
    }

    function avoidWidow(title) {
      var link = title.querySelector('a') || title;
      var raw = link.dataset.lejRaw;
      if (raw === undefined) raw = link.dataset.lejRaw = link.textContent.replace(/\u00A0/g, ' ');
      link.textContent = raw;
      var words = raw.trim().split(/\s+/);
      if (words.length < 3) return;              /* con dos palabras no hay nada que reequilibrar */

      var lh = parseFloat(getComputedStyle(title).lineHeight);
      var lines = Math.round(title.scrollHeight / lh);
      if (lines < 2) return;

      var node = link.firstChild;
      if (!node || node.nodeType !== 3) return;
      var lastSpace = raw.lastIndexOf(' ');
      if (lastSpace < 0) return;
      var prevSpace = raw.lastIndexOf(' ', lastSpace - 1);
      var lastTop = lineTop(node, lastSpace + 1, raw.length);
      var prevTop = lineTop(node, prevSpace + 1, lastSpace);
      if (lastTop === null || prevTop === null || lastTop <= prevTop + 1) return;  /* no hay viuda */

      link.textContent = raw.slice(0, lastSpace) + '\u00A0' + raw.slice(lastSpace + 1);
      if (Math.round(title.scrollHeight / lh) > lines) link.textContent = raw;     /* no cabía */
    }

    /* Hasta Codea el mensaje de envío gratis seguía en móvil al cuerpo del
       título del producto (Hugo 2026-08-07). Ahora va siempre a `--lej-fs-ship`. */
    function syncShipMessage(fitted) {
      var msgs = document.querySelectorAll(SECTION + ' .free-shipping-bar__message');
      Array.prototype.forEach.call(msgs, function (m) {
        /* Codea v1.3: el mensaje va a small 12 y el título a ui 14, así que ya no
           sigue al cuerpo del título; solo se limpia el inline que hubiera. */
        m.style.fontSize = '';
      });
    }

    /* v2 ya no necesita observar el alto de la columna: la foto tiene medidas
       fijas y solo depende del ANCHO disponible, que cambia con el viewport (ya
       hay listener de resize) o al re-renderizar el carrito. */
    function layoutItems() {
      var items = Array.prototype.slice.call(document.querySelectorAll(SECTION + ' .lejci'));
      var titles = items.map(function (i) { return i.querySelector('.lejci__title'); }).filter(Boolean);
      syncShipMessage(fitAllTitles(titles));
      titles.forEach(avoidWidow);
      items.forEach(function (item) {
        var info = item.querySelector('.lejci__info');
        var img = item.querySelector('.lejci__image');
        if (!info || !img) return;
        setPhotoWidth(img, info, item);
      });
    }

    layoutItems();
    document.addEventListener('on:cart:after-merge', layoutItems);
    document.addEventListener('dispatch:cart-drawer:open', function () { setTimeout(layoutItems, 50); });
    window.addEventListener('resize', layoutItems);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layoutItems);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', layoutItems);
    }

    function refresh() {
      var form = cartForm();
      if (form && typeof form.refresh === 'function') {
        form.refresh();
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
    }

    /* ── "Modificar": abre/cierra el selector de talla ─────────────────────
       Con animación (Hugo 2026-08-07): se anima height + margin-top +
       padding-top + opacity entre 0 y su valor real, y al terminar se limpian
       los inline (abierto queda en auto; cerrado recupera [hidden]). Timeout en
       vez de transitionend: transicionan 4 propiedades y dispararía 4 veces. */
    var SIZE_ANIM_MS = 250;

    function finishPanelAnim(panel, hide) {
      panel.__lejAnim = null;
      panel.classList.remove('is-animating');
      panel.style.height = '';
      panel.style.marginTop = '';
      panel.style.paddingTop = '';
      panel.style.opacity = '';
      if (hide) panel.setAttribute('hidden', '');
    }

    function openSizePanel(panel) {
      if (panel.__lejAnim) clearTimeout(panel.__lejAnim);
      panel.removeAttribute('hidden');
      var cs = getComputedStyle(panel);
      var mt = cs.marginTop;
      var pt = cs.paddingTop;
      var h = panel.scrollHeight;
      panel.style.height = '0px';
      panel.style.marginTop = '0px';
      panel.style.paddingTop = '0px';
      panel.style.opacity = '0';
      panel.getBoundingClientRect();
      panel.classList.add('is-animating');
      panel.style.height = h + 'px';
      panel.style.marginTop = mt;
      panel.style.paddingTop = pt;
      panel.style.opacity = '1';
      panel.__lejAnim = setTimeout(function () { finishPanelAnim(panel, false); }, SIZE_ANIM_MS);
    }

    function closeSizePanel(panel) {
      if (!panel || panel.hasAttribute('hidden')) return;
      var item = panel.closest('.lejci');
      var btn = item && item.querySelector('.js-lejci-edit');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel.__lejAnim) clearTimeout(panel.__lejAnim);
      panel.style.height = panel.scrollHeight + 'px';
      panel.getBoundingClientRect();
      panel.classList.add('is-animating');
      panel.style.height = '0px';
      panel.style.marginTop = '0px';
      panel.style.paddingTop = '0px';
      panel.style.opacity = '0';
      panel.__lejAnim = setTimeout(function () { finishPanelAnim(panel, true); }, SIZE_ANIM_MS);
    }

    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest(SECTION + ' .js-lejci-edit');
      if (!btn) return;
      evt.preventDefault();
      var item = btn.closest('.lejci');
      var panel = item && item.querySelector('.lejci__sizes');
      if (!panel) return;
      if (panel.hasAttribute('hidden')) {
        openSizePanel(panel);
        btn.setAttribute('aria-expanded', 'true');
      } else {
        closeSizePanel(panel);
      }
    });

    /* Clic FUERA del desplegable → se cierra (Hugo 2026-08-07). El propio
       botón "Modificar" se excluye para no pisarse con el toggle de arriba;
       abrir el selector de otra línea sí cierra los demás. */
    document.addEventListener('click', function (evt) {
      var open = document.querySelectorAll(SECTION + ' .lejci__sizes:not([hidden])');
      if (!open.length) return;
      var editBtn = evt.target.closest(SECTION + ' .js-lejci-edit');
      open.forEach(function (panel) {
        if (panel.contains(evt.target)) return;
        if (editBtn && editBtn.closest('.lejci') === panel.closest('.lejci')) return;
        closeSizePanel(panel);
      });
    });

    /* ── Cambio de talla ─────────────────────────────────────────────────────
       Shopify no permite cambiar la variante de una línea en una sola llamada:
       se añade la nueva variante (add.js) arrastrando cantidad y properties y,
       SOLO si el add responde OK, se borra la línea vieja (change.js qty 0).
       En este orden porque add.js puede fallar (422: talla agotada en carrera,
       o stock insuficiente para la cantidad — los chips solo vienen disabled
       si la talla está agotada DEL TODO) y fetch no rechaza por HTTP 422: con
       el orden inverso la línea vieja ya estaba borrada y el producto
       desaparecía del carrito sin error. Si el add falla, el carrito no ha
       cambiado: no hay refresh, solo el mensaje en el panel. Si la nueva talla
       ya estaba en el carrito, Shopify fusiona las dos líneas por sí solo.    */
    document.addEventListener('click', function (evt) {
      var chip = evt.target.closest(SECTION + ' .js-lejci-size');
      if (!chip || chip.disabled) return;
      evt.preventDefault();

      /* Clic en la talla YA seleccionada → solo cierra el desplegable */
      if (chip.classList.contains('is-current')) {
        closeSizePanel(chip.closest('.lejci__sizes'));
        return;
      }

      var lineKey = chip.dataset.lineKey;
      var variantId = parseInt(chip.dataset.variantId, 10);
      var panel = chip.closest('.lejci__sizes');
      var errEl = panel ? panel.querySelector('[data-lej-size-error]') : null;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (panel) panel.style.pointerEvents = 'none';

      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (i) { return i.key === lineKey; })[0];
          var properties = line && line.properties ? line.properties : null;
          var sellingPlan = line && line.selling_plan_allocation
            ? line.selling_plan_allocation.selling_plan.id
            : null;
          /* Cantidad del carrito real, no del data- pintado (podría estar rancio) */
          var quantity = (line && line.quantity) || parseInt(chip.dataset.quantity, 10) || 1;

          var payload = { id: variantId, quantity: quantity };
          if (properties && Object.keys(properties).length) payload.properties = properties;
          if (sellingPlan) payload.selling_plan = sellingPlan;

          return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [payload] })
          }).then(function (addRes) {
            if (!addRes.ok) {
              /* El 422 de add.js trae `description` ya localizada por Shopify */
              return addRes.json().catch(function () { return {}; }).then(function (err) {
                var msg = (err && (err.description || err.message))
                  || (window.theme && theme.strings && theme.strings.noStock)
                  || 'Not available';
                var handled = new Error(msg);
                handled.lejSizeChange = true;
                throw handled;
              });
            }
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: lineKey, quantity: 0 })
            });
          });
        })
        .then(function () { refresh(); })
        .catch(function (err) {
          if (panel) panel.style.pointerEvents = '';
          if (err && err.lejSizeChange) {
            /* add.js falló → el carrito está intacto: sin refresh, solo aviso */
            if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
            chip.disabled = true;
            chip.setAttribute('aria-disabled', 'true');
          } else {
            /* Error de red u otro imprevisto: repintar del estado del servidor */
            refresh();
          }
        });
    });

    /* ── "Cómpralo con": la tarjeta ENTERA añade el accesorio ──────────────
       Una vez está en el carrito la sección se repinta y la tarjeta pasa a ser
       un <a> a la PDP, así que este handler ya no la coge. */
    document.addEventListener('click', function (evt) {
      var card = evt.target.closest(SECTION + ' .js-lejpc-add');
      if (!card) return;
      evt.preventDefault();

      var variantId = card.dataset.variantId;
      if (!variantId) return;
      card.classList.add('is-busy');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function () { refresh(); })
        .finally(function () { card.classList.remove('is-busy'); });
    });

    /* `finally` y no `catch` en los tres `add.js` de aquí abajo: `is-busy` NO se
       puede dejar a que se lo lleve el repintado. El contenedor del carrito
       vacío es `data-merge-attributes`, que solo refresca ATRIBUTOS — dentro
       siguen los mismos nodos desde que cargó la página. Quitando la clase solo
       al fallar, la tarjeta que habías añadido se quedaba en
       `opacity: .45; pointer-events: none` PARA SIEMPRE en cuanto vaciabas el
       carrito y el bloque volvía a aparecer. */

    /* ── Tarjeta del MATCH: desplegable de tallas ──────────────────────────
       El producto del match siempre tiene varias tallas, así que ni el "+" ni la
       pastilla añaden directamente: abren esta lista (solo tallas DISPONIBLES) y
       es la talla la que añade. La lista se coloca a mano (el carrusel y el
       scroller del cajón recortan) y se cierra en cuanto algo se mueva: scroll
       del body del drawer, resize, Escape o clic fuera. */
    function closeMatch(list) {
      if (!list || list.hidden) return;
      list.hidden = true;
      var card = list.closest('[data-lejmatch]');
      if (card) {
        card.querySelectorAll('.js-lejmatch-open').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
        });
      }
    }

    function closeAllMatches() {
      document.querySelectorAll(SECTION + ' .lejmatch__list').forEach(closeMatch);
    }

    /* Coloca la lista en coordenadas de VENTANA y las traduce al bloque
       contenedor real, que es `.drawer.js-cart-drawer` (`position: fixed`): el
       primer ancestro posicionado por fuera de los tres recortes que hay por el
       camino (`.lejrec__track`, `.lejrec__body` y el scroller `.lejcd__body`).
       Se lee con `offsetParent` en vez de cablear un selector, así el día que
       cambie el marcado sigue siendo el bloque contenedor de verdad.
       Ojo: `position: fixed` NO vale aquí — `.drawer` lleva `transform` y
       `.lejrec` `filter`, y las dos cosas crean bloque contenedor para `fixed`.

       El alto disponible es la VENTANA entera, no el hueco sobre la pastilla:
       el desplegable pasa por encima del header y del footer del cajón (ver el
       z-index de `.lejcd__body`), así que caben todas las tallas. */
    function placeMatch(list, anchor) {
      var a = anchor.getBoundingClientRect();
      var GAP = 6;
      var MARGIN = 8;

      list.style.left = '0px';
      list.style.top = '0px';
      /* Techo real: la ventana. Solo hay scroll dentro de la lista si ni así cabe. */
      list.style.maxHeight = window.innerHeight - MARGIN * 2 + 'px';
      var h = list.offsetHeight;
      var w = list.offsetWidth;
      var above = a.top - GAP - MARGIN;
      var below = window.innerHeight - a.bottom - GAP - MARGIN;
      var vTop; /* en coordenadas de VENTANA; se pasa a locales al final */

      if (h <= above) {
        vTop = a.top - GAP - h;
      } else if (h <= below) {
        vTop = a.bottom + GAP;
      } else {
        /* No cabe ni arriba ni abajo de la pastilla: se coloca pegada al borde
           superior y ocupa lo que haga falta de la ventana. */
        vTop = MARGIN;
      }

      /* Alineada a la pastilla y metida dentro de la ventana a lo ancho. */
      var vLeft = Math.max(MARGIN, Math.min(a.left, window.innerWidth - w - MARGIN));

      var base = list.offsetParent ? list.offsetParent.getBoundingClientRect() : { top: 0, left: 0 };
      list.style.top = vTop - base.top + 'px';
      list.style.left = vLeft - base.left + 'px';
    }

    document.addEventListener('click', function (evt) {
      var opener = evt.target.closest(SECTION + ' .js-lejmatch-open');
      var pick = evt.target.closest(SECTION + ' .js-lejmatch-pick');

      if (!opener && !pick) {
        if (!evt.target.closest(SECTION + ' .lejmatch__list')) closeAllMatches();
        return;
      }

      if (opener) {
        evt.preventDefault();
        var card = opener.closest('[data-lejmatch]');
        var list = card.querySelector('.lejmatch__list');
        if (!list) return;
        var wasOpen = !list.hidden;
        closeAllMatches();
        if (wasOpen) return;
        list.hidden = false;
        placeMatch(list, card.querySelector('.lejpc__match') || opener);
        card.querySelectorAll('.js-lejmatch-open').forEach(function (b) {
          b.setAttribute('aria-expanded', 'true');
        });
        return;
      }

      evt.preventDefault();
      var mcard = pick.closest('[data-lejmatch]');
      var vid = pick.dataset.variantId;
      if (!vid) return;
      closeMatch(mcard.querySelector('.lejmatch__list'));
      mcard.classList.add('is-busy');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
      })
        .then(function () { refresh(); })
        .finally(function () { mcard.classList.remove('is-busy'); });
    });

    /* ── <select> nativo de talla (móvil) ────────────────────────────────
       Mismo destino que `.js-lejmatch-pick`, pero disparado por el `change` del
       control nativo. Ver el porqué en el marcado de `lej-product-card.liquid`:
       el listbox propio lo recortan los `overflow` del carrusel en Safari de
       iOS, y el desplegable del sistema no vive en la página. */
    document.addEventListener('change', function (evt) {
      var sel = evt.target.closest(SECTION + ' .js-lejpc-nativesize');
      if (!sel || !sel.value) return;

      var scard = sel.closest('[data-lejmatch]');
      var svid = sel.value;
      /* El carrito se repinta entero, pero si la petición falla hay que poder
         volver a elegir la misma talla: se devuelve al placeholder. */
      sel.selectedIndex = 0;
      closeAllMatches();
      if (scard) scard.classList.add('is-busy');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(svid, 10), quantity: 1 }] })
      })
        .then(function () { refresh(); })
        .finally(function () { if (scard) scard.classList.remove('is-busy'); });
    });

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') closeAllMatches();
    });
    /* Al cambiar de tamaño el hueco arriba/abajo cambia y la decisión ya no vale.
       Y al scrollear TAMBIÉN hay que cerrar: la lista cuelga de `.drawer`
       (`position: fixed`), que no se mueve con el scroller del cajón, así que se
       quedaría flotando lejos de su pastilla. */
    window.addEventListener('resize', closeAllMatches);
    document.addEventListener('scroll', function (evt) {
      if (evt.target && evt.target.closest && evt.target.closest(SECTION)) closeAllMatches();
    }, true);
  })();
